export default __webpack_public_path__ + "static/media/partner-acknoledger.cd0508b2.svg";